export const RETRIEVE_VEHICLES = "RETRIEVE_VEHICLES";
export const SET_VEHICLES_INFO = "SET_VEHICLES_INFO";
